<template>
    <div>page 500</div>
</template>
<script>
    export default {
        
    }
</script>